<template>
  <div class="apply">
    <Header title="请假申请"></Header>
    <div
      class="apply-body"
      :style="this.$route.query.list.type == '0' ? ' height:auto' : ''"
    >
      <!-- <div>
        <p class="apply-title">{{ this.topInfo.KCMC }}</p>
        <p class="apply-num">学时：{{ this.topInfo.ZXS }}</p>
        <p class="apply-num">学分：{{ this.topInfo.XF }}</p>
      </div> -->
      <span class="attention"
        >注：请假7天以上需要上传家长身份证、知情同意书、证明材料</span
      >
      <div class="apply-inputs">
        <div class="apply-input">
          <van-field
            v-model="qjkssj.mc"
            label="请假开始时间"
            right-icon="arrow"
            input-align="right"
            placeholder="请点击选择"
            readonly
            @click="onShow1('请假开始时间', 'qjkssj')"
          />
        </div>
        <div class="apply-input">
          <van-field
            v-model="qjjssj.mc"
            label="请假结束时间"
            right-icon="arrow"
            input-align="right"
            placeholder="请点击选择"
            readonly
            @click="onShow1('请假结束时间', 'qjjssj')"
          />
        </div>
        <div class="apply-input">
          <van-field
            v-model="day"
            label="请假天数"
            input-align="right"
            readonly
          />
        </div>
        <div class="apply-input">
          <van-field
            v-model="qjlx.mc"
            label="请假类型"
            input-align="right"
            right-icon="arrow"
            placeholder="请点击选择"
            readonly
            @click="onShow('请假类型', 'qjlx')"
          />
        </div>
        <!-- 查看的时候flag为true  -->
        <!-- 申请编辑的时候flag为false  -->
        <!-- 查看的时候为3的有  申请的时候有 -->
        <div
          class="apply-input"
          v-if="
            this.$route.query.list.xsqjid == undefined ||
              (!flag && qjiswfmes == '3')
          "
        >
          <van-field
            v-model="person"
            label="审核人"
            input-align="right"
            placeholder="请点击选择"
            right-icon="arrow"
            readonly
            @click="isPopShow()"
          />
        </div>
        <div class="apply-input">
          <van-field
            v-model="qjyy"
            label="请假原因"
            input-align="right"
            type="textarea"
            placeholder="请点击填写"
            :readonly="flag"
          />
        </div>
        <div class="apply-input">
          <van-field label="家长身份证" input-align="right" readonly>
            <template #button>
              <van-uploader
                v-if="!flag"
                :after-read="
                  file => {
                    afterRead(file, 'jzsfz');
                  }
                "
                preview-size="120px"
                :max-size="10 * 1024 * 1024"
                @oversize="onOversize"
                style="max-width:200px"
                :disabled="flag"
                :max-count="maxCount"
              >
                <van-button icon="plus" type="primary">
                  {{ jzsfz.mc }}
                </van-button>
              </van-uploader>
              <span class="download" v-else @click="down(1)">{{
                jzsfz.mc
              }}</span>
            </template>
          </van-field>
        </div>
        <div class="apply-input">
          <van-field label="知情同意书" input-align="right" readonly>
            <template #button>
              <van-uploader
                v-if="!flag"
                :after-read="
                  file => {
                    afterRead(file, 'zqtys');
                  }
                "
                preview-size="120px"
                :max-size="10 * 1024 * 1024"
                @oversize="onOversize"
                style="max-width:200px"
                :disabled="flag"
                :max-count="maxCount"
              >
                <van-button icon="plus" type="primary">
                  {{ zqtys.mc }}
                </van-button>
              </van-uploader>
              <span class="download" v-else @click="down(2)">{{
                zqtys.mc
              }}</span>
            </template>
          </van-field>
        </div>
        <div class="apply-input">
          <van-field label="证明材料" input-align="right" readonly>
            <template #button>
              <van-uploader
                v-if="!flag"
                :after-read="
                  file => {
                    afterRead(file, 'zmcl');
                  }
                "
                preview-size="120px"
                :max-size="10 * 1024 * 1024"
                @oversize="onOversize"
                style="max-width:200px"
                :disabled="flag"
                :max-count="maxCount"
              >
                <van-button icon="plus" type="primary">
                  {{ zmcl.mc }}
                </van-button>
              </van-uploader>
              <span class="download" v-else @click="down(3)">{{
                zmcl.mc
              }}</span>
            </template>
          </van-field>
        </div>
        <div class="apply-input">
          <van-field label="其他" input-align="right" readonly>
            <template #button>
              <van-uploader
                v-if="!flag"
                :after-read="
                  file => {
                    afterRead(file, 'qt');
                  }
                "
                preview-size="120px"
                :max-size="10 * 1024 * 1024"
                @oversize="onOversize"
                style="max-width:200px"
                :disabled="flag"
                :max-count="maxCount"
              >
                <van-button icon="plus" type="primary">
                  {{ qt.mc }}
                </van-button>
              </van-uploader>
              <span class="download" v-else @click="down(4)">{{ qt.mc }}</span>
            </template>
          </van-field>
        </div>
        <div class="apply-input" v-if="this.xjsj.mc != undefined">
          <van-field
            v-model="xjsj.mc"
            label="销假时间"
            right-icon="arrow"
            input-align="right"
            readonly
          />
        </div>
        <div class="apply-input" v-if="this.xjsm != ''">
          <van-field
            v-model="xjsm"
            label="销假说明"
            input-align="right"
            type="textarea"
            readonly
          />
        </div>
      </div>
    </div>
    <button
      class="apply-btn"
      v-if="this.$route.query.list.type != '0'"
      @click="submitApply()"
    >
      提交申请
    </button>
    <!-- 审核人popup -->
    <van-popup v-model="isShow" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="isShow = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            @click="personTap($event, index)"
            v-for="(item, index) in personList"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
    <van-popup v-model="show1" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :title="valueList.label"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="
          (value, index) => {
            onConfirm1(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
import service from "@/utils/request";
export default {
  data() {
    return {
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      isShow: false,
      day: "0",
      qjlx: {},
      xjsj: {},
      xjsm: "",
      qjyy: "",
      jzsfz: { mc: "上传文件" },
      zqtys: { mc: "上传文件" },
      zmcl: { mc: "上传文件" },
      qt: { mc: "上传文件" },
      personList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      person: "",
      personId: "",
      reset: "",
      resetId: "",
      show: false,
      columns: {},
      valueList: {
        label: "",
        value: "",
        item: []
      },
      fileList: [],
      maxCount: 1,
      show1: false,
      qjkssj: {},
      qjjssj: {},
      yw: "385-1",
      flag: false,
      qjiswfmes: ""
    };
  },
  created() {
    this.$route.query.list=JSON.parse(this.$route.query.list)
    this.getList();
  },
  methods: {
    async down(xh) {
      let data = {
        fileurl: this.fileList["fjpath" + xh],
        qzwffilename: this.fileList["fjname" + xh],
        ermsg: "",
        shyj: ""
      };
      localStorage.setItem("shyjData", JSON.stringify(data));
      let type = this.fileList["fjname" + xh].substring(
        this.fileList["fjname" + xh].lastIndexOf(".") + 1,
        this.fileList["fjname" + xh].length
      );
      if (
        type.indexOf("xsl") !== -1 ||
        type.indexOf("xslx") !== -1 ||
        type.indexOf("xls") !== -1
      ) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else if (type.indexOf("docx") !== -1) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else if (type.indexOf("pdf") !== -1) {
        this.$router.push({ path: "/teacher/filePreview" });
      } else if (
        type.indexOf("jpg") !== -1 ||
        type.indexOf("png") !== -1 ||
        type.indexOf("jpeg") !== -1
      ) {
        this.$route.query.list.route='/holiday/apply'
        this.$router.push({
          path: "/teacher/filePreview",
          query: { list: this.$route.query.list }
        });
      } else {
        this.$toast.fail('抱歉!当前文件不支持预览');
      }
    },
    async getList() {
      let res = {};
      if (!!this.$route.query.list.xsqjid) {
        this.qjiswfmes = this.$route.query.list.qjiswfmes;
        if (this.$route.query.list.type == 0) {
          this.flag = true;
          // 查看
          res = await Api.xsqjadd({
            type: "ck",
            xsqjid: this.$route.query.list.xsqjid
          });
        } else {
          // 编辑
          res = await Api.xsqjadd({
            type: "edit",
            xsqjid: this.$route.query.list.xsqjid
          });
        }
        this.fileList = res.data.qjxxmap;
        // 赋值
        this.qjkssj = {
          dm: this.fileList.kssj,
          mc: this.formatSjMc(new Date(this.fileList.kssj))
        };
        this.qjjssj = {
          dm: this.fileList.jssj,
          mc: this.formatSjMc(new Date(this.fileList.jssj))
        };
        if (this.fileList.xjsj != "") {
          this.xjsj = {
            dm: this.fileList.xjsj,
            mc: this.formatSjMc(new Date(this.fileList.xjsj))
          };
        }
        this.day = this.fileList.qjts;
        this.xjsm = this.fileList.xjyy;
        this.qjyy = this.fileList.sqyy;
        this.jzsfz.mc =
          this.fileList.fjname1 == "" ? "未上传文件" : this.fileList.fjname1;
        this.zqtys.mc =
          this.fileList.fjname2 == "" ? "未上传文件" : this.fileList.fjname2;
        this.zmcl.mc =
          this.fileList.fjname3 == "" ? "未上传文件" : this.fileList.fjname3;
        this.qt.mc =
          this.fileList.fjname4 == "" ? "未上传文件" : this.fileList.fjname4;
        this.columns.qjlx = res.data.qjlxlist.map((item, index) => {
          if (item.dm == this.fileList.qjlx) {
            this.qjlx = {
              mc: item.dmmc,
              dm: item.dm
            };
          }
          return {
            text: item.dmmc,
            value: item.dm
          };
        });
      } else {
        // 直接申请
        res = await Api.xsqjadd();
        this.columns.qjlx = res.data.qjlxlist.map((item, index) => {
          return {
            text: item.dmmc,
            value: item.dm
          };
        });
      }
    },
    // 弹出选择器
    onShow1(label, value) {
      if (this.flag) {
        return;
      }
      if (value == "qjjssj" && this.qjkssj.dm == undefined) {
        this.$toast.fail("请先选择请假开始时间!");
        return;
      }
      this.show1 = true;
      this.valueList.label = label;
      this.valueList.value = value;
    },
    onConfirm1(value, index, value1) {
      this.show1 = false;
      let chooseDate = new Date(value);
      if (value1 == "qjjssj") {
        let date = new Date(this.qjkssj.dm.replace(/-/g, "/"));
        let time = chooseDate - date;
        if (chooseDate <= date) {
          this.$toast.fail("请假结束时间要在请假开始时间之后!");
          return;
        }
        this.day = this.getDaysBetween(date, chooseDate);

        this.getPeople();
      }

      if (value1 == "qjkssj" && this.qjjssj.dm != undefined) {
        let date = new Date(this.qjjssj.dm.replace(/-/g, "/"));
        if (chooseDate >= date) {
          this.$toast.fail("请假结束时间要在请假开始时间之后!");
          return;
        }
        this.day = this.getDaysBetween(chooseDate, date);

        this.getPeople();
      }
      this[value1].mc = this.formatSjMc(chooseDate);
      this[value1].dm = this.formatSjDm(chooseDate);
    },
    getDaysBetween(startDate, endDate) {
      if (
        startDate.getFullYear() == endDate.getFullYear() &&
        startDate.getMonth() == endDate.getMonth() &&
        startDate.getDate() == endDate.getDate()
      ) {
        return 1;
      }
      if (
        startDate.getFullYear() == endDate.getFullYear() &&
        startDate.getMonth() == endDate.getMonth() &&
        startDate.getDate() < endDate.getDate()
      ) {
        return endDate.getDate() - startDate.getDate() + 1;
      }
      if (
        startDate.getFullYear() == endDate.getFullYear() &&
        startDate.getMonth() < endDate.getMonth()
      ) {
        return (
          (endDate.getMonth() - startDate.getMonth()) *
            this.mGetDate(startDate.getFullYear(), endDate.getMonth()) +
          (endDate.getDate() - startDate.getDate() + 1)
        );
      }
      if (startDate.getFullYear() < endDate.getFullYear()) {
        if (
          (startDate.getFullYear() % 4 == 0 &&
            startDate.getFullYear() % 100 != 0) ||
          startDate.getFullYear() % 400 == 0
        ) {
          return (
            (endDate.getFullYear() - startDate.getFullYear()) * 366 +
            (endDate.getMonth() - startDate.getMonth()) *
              this.mGetDate(startDate.getFullYear(), endDate.getMonth()) +
            (endDate.getDate() - startDate.getDate() + 1)
          );
        } else {
          return (
            (endDate.getFullYear() - startDate.getFullYear()) * 365 +
            (endDate.getMonth() - startDate.getMonth()) *
              this.mGetDate(startDate.getFullYear(), endDate.getMonth()) +
            (endDate.getDate() - startDate.getDate() + 1)
          );
        }
      }
    },
    mGetDate(year, month) {
      var d = new Date(year, month, 0);
      return d.getDate();
    },
    formatSjMc(date) {
      return (
        (date.getFullYear() < 10
          ? "0" + date.getFullYear()
          : date.getFullYear()) +
        "年" +
        (Number(date.getMonth()) + 1 < 10
          ? "0" + (Number(date.getMonth()) + 1)
          : Number(date.getMonth()) + 1) +
        "月" +
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
        "日 " +
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
        "时" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        "分"
      );
    },
    formatSjDm(date) {
      return (
        (date.getFullYear() < 10
          ? "0" + date.getFullYear()
          : date.getFullYear()) +
        "-" +
        (Number(date.getMonth()) + 1 < 10
          ? "0" + (Number(date.getMonth()) + 1)
          : Number(date.getMonth()) + 1) +
        "-" +
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
        " " +
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":00"
      );
    },
    afterRead(file, value) {
      this[value].dm = file.file;
      file.status = "uploading";
      file.message = "上传中...";
      setTimeout(() => {
        file.status = "success";
      }, 500);
      this[value].mc = file.file.name;
    },
    onOversize(file) {
      this.$toast.fail("文件大小不能超过10M");
    },
    async submitApply() {
      if (!!!this.$route.query.list.xsqjid && this.person == "") {
        this.$toast.fail("请填写完整~");
        return;
      }
      if (
        JSON.stringify(this.qjkssj) == "{}" ||
        JSON.stringify(this.qjjssj) == "{}" ||
        JSON.stringify(this.qjlx) == "{}" ||
        this.qjyy == "" ||
        this.person == ""
      ) {
        this.$toast.fail("请填写完整~");
        return;
      }
      if (this.day > 7) {
        if (
          this.jzsfz.dm == undefined ||
          this.zqtys.dm == undefined ||
          this.zmcl.dm == undefined
        ) {
          this.$toast.fail(
            "请假7天以上需要上传家长身份证、知情同意书、证明材料!"
          );
          return;
        }
      }
      const params = {
        type: this.$route.query.list.xsqjid == undefined ? "add" : "edit",
        xsqjid: this.$route.query.list.xsqjid,
        userids: this.personId,
        ywcode: this.yw,
        kssj: this.qjkssj.dm,
        jssj: this.qjjssj.dm,
        qjts: this.day,
        qjlx: this.qjlx.dm,
        qjyy: this.qjyy,
        jzsfz: this.jzsfz.dm,
        zqtys: this.zqtys.dm,
        zmcl: this.zmcl.dm,
        qt: this.qt.dm
      };
      const res = await Api.xsqjsave(params);

      if (res.code == 1) {
        this.$toast.success("申请成功!");
        setTimeout(() => {
          this.$router.replace("/holiday/index");
        }, 1500);
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    // 弹出选择器
    onShow(label, value) {
      if (this.flag) {
        return;
      }
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value.text;
      this[value1].dm = value.value;
    },
    // 审核人
    resetCancel() {
      this.isShow = false;
      this.person = this.reset;
      this.personId = this.resetId;
    },
    async getPeople() {
      this.yw = "385-1";
      if (this.day >= 7 && this.day <= 14) {
        this.yw = "385-2";
      } else if (this.day > 15) {
        this.yw = "385-3";
      }
      const params = {
        ywcode: this.yw,
        ywid: ""
      };
      const res = await Api.selectReviewerApi(params);
      let concatList = [];
      res.data.forEach((item, index) => {
        concatList[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.personList = this.personList.concat(concatList);
    },
    isPopShow() {
      if (this.day == "0") {
        this.$toast.fail("请选择请假起止时间！");
        return;
      }
      this.isShow = !this.isShow;
    },
    close() {
      this.isShow = false;
    },
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.personList[res].isBtn == 0) {
        this.personList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.personList[res].isBtn == 1) {
        this.personList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.personList) {
        if (this.personList[res].name == "全部") {
          this.personList[i].isBtn = 0;
          this.personList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.personList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.personList[i].isBtn == 1) {
          strList = strList.concat(this.personList[i].name);
          idList = idList.concat(this.personList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    }
  }
};
</script>

<style lang="less" scoped>
.apply {
  height: calc(~"100vh - 50px");
  position: relative;
}
.apply-body {
  padding: 0 20px;
  overflow: auto;
  height: calc(~"100% - 80px");
  .attention {
    color: red;
    font-size: 12px;
  }
}
.apply-body .apply-title {
  font-size: 18px;
  color: @attendance-color-1;
  font-weight: 600;
}
.apply-body .apply-num {
  font-size: 14px;
  color: @attendance-color-2;
  margin-top: 8px;
}
.apply-inputs {
  margin-top: 17px;
}
.apply-inputs .apply-input {
  padding: 9px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid @attendance-border-color-6;
  color: @attendance-color-1;
  .download {
    width: 200px;
    display: inline-flex;
    align-items: center;
    height: 44px;
    padding: 0 15px;
    color: #fff;
    background-color: #07c160;
    opacity: 0.5;
    border-radius: 3px;
    border: 1px solid #07c160;
    word-break: break-all;
  }
}
.apply-input input {
  flex: 1;
  text-align: right;
  color: @attendance-color-1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 20px;
}
.apply-input input::placeholder {
  color: @attendance-background-color-2;
  font-size: 16px;
}
.apply .apply-btn {
  position: absolute;
  bottom: 20px;
  background-color: @attendance-background-color-1;
  padding: 11px 0;
  color: @attendance-color-3;
  border-radius: 3px;
  width: 90%;
  margin-left: 5%;
}

// 审核人
.apply-pop {
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  max-height: 40%;
  overflow-y: scroll;
}
.close-icon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.pop-title {
  display: flex;
  justify-content: space-between;
  padding: 13px;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  z-index: 9;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
}
.confirm-icon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.apply-pop .person {
  padding: 20px 20px 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: 48px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 15px;
}
.apply-pop .person .per-btn {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.person .cur {
  background-color: @attendance-background-color-1;
  color: @attendance-background-color-7;
}
</style>
<style lang="less">
.apply-inputs {
  .van-cell {
    padding: 0;
  }
  .van-cell__title,
  .van-cell.van-field .van-cell__title.van-field__label > span {
    width: auto;
    height: 22px;
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
    flex: inherit;
  }
  .van-icon-eye {
    font-family: "iconfont" !important;
    font-size: 22px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #212f6e;
  }
  .van-icon-eye::before {
    content: "\e6be";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/holiday/apply.vue